<template>
  <Slide
    width="233"
    :closeOnNavigation="true"
    @openMenu="handleOpenMenu"
    @closeMenu="handleCloseMenu"
    :class="{ mask: opened }"
  >
    <div class="container">
      <logo class="burger-menu-logo" />
      <ul class="nav-container">
        <header-link
          v-for="link in pageLinks"
          :key="link.to"
          :to="link.to"
          :label="link.label"
          class="link"
        />
        <li>
          <slot name="items" />
        </li>
      </ul>
    </div>
    <slot name="actions" />
  </Slide>
</template>

<script>
import { Slide } from 'vue-burger-menu';
import Logo from '@/components/header/Logo.vue';
import HeaderLink from '@/components/header/Link.vue';

import { ROUTER_PATHS } from '@/router/constants';

export default {
  components: {
    Slide,
    Logo,
    HeaderLink,
  },
  props: {
    links: Array,
  },
  data() {
    return {
      opened: false,
    };
  },
  computed: {
    pageLinks() {
      const homeLink = {
        to: ROUTER_PATHS.HOME,
        label: this.$t('home.page'),
      };

      return [homeLink, ...this.links];
    },
  },
  methods: {
    handleOpenMenu() {
      this.opened = true;
    },
    handleCloseMenu() {
      this.opened = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors.scss';

.container,
.nav-container {
  display: flex;
  flex-direction: column;
}

.burger-menu-logo {
  margin-left: -17px;
  margin-bottom: 20px;
}

.link {
  margin: 0;
  padding-bottom: 20px;
}

.mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
}
</style>

<style lang="scss">
@import '~@/assets/styles/colors.scss';

.bm-burger-button {
  height: 14px !important;
  width: 20px !important;
  margin-top: -5px !important;
  margin-right: 100px !important;
}

.bm-menu {
  background-color: $white !important;
  padding-top: 0 !important;
}

.bm-cross-button {
  padding-top: 10px !important;
}

.bm-cross {
  background-color: $dark-grey !important;
  height: 22px !important;
  width: 3px !important;
}

.bm-overlay {
  background: none !important;
}

.bm-item-list {
  margin: 0 10px !important;
  height: 100vh !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
}

.bm-item-list > * > span {
  color: inherit !important;
  margin: 0 !important;
  font-weight: inherit !important;
}
</style>
